export const PORTAL_MOUNT_EVENT = 'akPortalMount';
export const PORTAL_UNMOUNT_EVENT = 'akPortalUnmount';